import type { CreateSupplierDto } from '@shared/dto/supplier/create-supplier.dto';
import type { UpdateSupplierDto } from '@shared/dto/supplier/update-supplier.dto';

export function toCreateSupplierDto(data: CreateSupplierDto): CreateSupplierDto {
  return {
    name: data.name,
    vatNumber: data.vatNumber,
    address: data.address || undefined,
    email: data.email || undefined,
    phone: data.phone || undefined,
  };
}

export function toUpdateSupplierDto(data: UpdateSupplierDto): UpdateSupplierDto {
  return {
    name: data.name,
    vatNumber: data.vatNumber,
    address: data.address || undefined,
    email: data.email || undefined,
    phone: data.phone || undefined,
  };
}
